module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/人才管理.d4e467d2.png";